import PaginatedComponent from '../PaginatedComponent';
import { createCustomSlice } from 'core/utils';

const initialState = {
    list: [],
    loading: false,
    page: null,
    pageLoading: false,
    selected: {}
};

const officeSlice = createCustomSlice({
    initialState,
    name: 'office',
    reducers: {
        setOfficePage (state, { payload }) {
            state.page = new PaginatedComponent({
                ...payload,
                loadingAction: officeActions.setOfficePageLoading,
                setAction: officeActions.setOfficePage
            });
        }
    },
    saga: [
        'getOffice',
        'getOfficeListing',
        'getOfficePage',
        'officeDelete',
        'officeRestore',
        'officeRegistration'
    ]
});

export const officeActions = officeSlice.actions;

export default officeSlice.reducer;
